import type { ListPageConfig } from '@/lib/filters/types'

/**
 * The agencies listing had one filter — a search box — and so was written as a raw `<Input>` plus
 * `useDebounceSearch`, with the term held in component state and never in the URL. That is why
 * its filter row looked different from every `FilterBar` page: not a styling drift, a different
 * component.
 *
 * One field is still a config. `FilterBar` debounces the search input itself, and
 * `useListPageState.setFilter` resets the page, so the page loses a hand-rolled debounce and a
 * first-render ref along with the bespoke markup.
 */
export const AGENCIES_ROUTE_CONFIG: ListPageConfig = {
  routeId: '/agencies/',
  pageId: 'agencies',
  // Keep an oversight portfolio of 21+ agencies visibly pageable and align this listing with the
  // platform's standard 20-row server pages. The shared related-org default remains unchanged.
  pagination: { pageSize: 20 },
  fields: [
    {
      id: 'q',
      label: 'Search',
      type: 'search',
      placeholder: 'Search agencies…',
      serverSide: true,
    },
  ],
}
